import { useGetApiV1LocationCountriesCountryidLangsAvailableLanguages } from '@/shared/api/generated';

/**
 * Hook para os idiomas disponíveis (dropdown) usados no seletor do formulário de
 * idioma. Envolve `GET /api/v1/location/countries/{countryId}/langs/available-languages`,
 * que retorna `{ key, value }[]` (key = `cultureInfo` como `pt-BR`, value = nome
 * de exibição).
 *
 * @param countryId - Id do país.
 */
export function useAvailableLanguages(countryId: number) {
  const query = useGetApiV1LocationCountriesCountryidLangsAvailableLanguages(countryId);

  return {
    options: query.data ?? [],
    isLoading: query.isLoading,
  } as const;
}
